import { contactInfo } from './mockData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 mb-4">
            <i className="ri-mail-send-line text-primary-600 text-sm"></i>
            <span className="text-primary-700 text-xs font-medium">合作联系</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mb-8 max-w-lg mx-auto">
            {contactInfo.desc}
          </p>

          <div className="bg-background-50 rounded-2xl p-6 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-100 mb-3">
                  <i className="ri-mail-line text-primary-600 text-xl"></i>
                </div>
                <div className="text-xs text-foreground-400 mb-1">商务邮箱</div>
                <div className="text-sm font-medium text-foreground-800">{contactInfo.email}</div>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-100 mb-3">
                  <i className="ri-wechat-line text-accent-600 text-xl"></i>
                </div>
                <div className="text-xs text-foreground-400 mb-1">微信客服</div>
                <div className="text-sm font-medium text-foreground-800">{contactInfo.wechat}</div>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-secondary-100 mb-3">
                  <i className="ri-qq-line text-secondary-600 text-xl"></i>
                </div>
                <div className="text-xs text-foreground-400 mb-1">QQ联系</div>
                <div className="text-sm font-medium text-foreground-800">{contactInfo.qq}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}